import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GET_STARTED_URL } from '../constants/global';
import { auth } from '../firebase';
import useUser from '../hooks/global/useUser';
import { isUserEmployeeOrAdmin } from '../utils/global/helper';
import { LoadedUser } from '../interfaces';

export default function NoAccountPage() {
  const navigate = useNavigate();
  const { user } = useUser();

  React.useEffect(() => {
    const isValidUser =
      user && user.business && isUserEmployeeOrAdmin(user as LoadedUser);
    if (isValidUser) {
      navigate('/');
    }
  }, [navigate, user]);

  return (
    <Box
      p={4}
      boxSizing="border-box"
      sx={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '1rem',
      }}>
      <div className="sign-up">
        <div className="text">
          <Typography variant="h1" align="center">
            You&apos;re not linked to a shop
          </Typography>
          <Typography variant="body1" align="center">
            To join another shop or set up your own, continue below to get
            started on Porter.
          </Typography>
        </div>
        <Button
          variant="contained"
          className="primary"
          href={GET_STARTED_URL}
          target="_blank"
          rel="noopener noreferrer">
          Get Started
        </Button>
        <Button
          variant="text"
          className="text-btn"
          onClick={() => auth.signOut().then(() => navigate('/'))}>
          Sign in with a different phone number
        </Button>
      </div>
    </Box>
  );
}
